
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useApiRequest from "../../../hook/useApiRequest";
import { API_ENDPOINTS } from "../../../constants/endPoints";


const userChatUserList = ({setOtherUser , setListData}) => {
  const { loading, fetchData } = useApiRequest();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);

  const [filters, setFilters] = useState({
    startDate: "",
    endDate: "",
    search: "",
    status:"",
    customer_type:"",
  });

  const limit = API_ENDPOINTS?.page_limit;
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const fetchCustomerData = async () => {
    try {
      const url = `${API_ENDPOINTS?.chat_users}`;
      const params = {
        offset: currentPage,
        limit: limit,
        search: filters.search || "",
        startDate: filters.startDate || "",
        endDate: filters.endDate || "",
        status: filters.status || "",
        customer_type: filters.customer_type || "",
        
      };
      const response = await fetchData(
        `${url}?${new URLSearchParams(params)}`,
        navigate
      );

  
      if (response) {
        setListData(Array.isArray(response) ? response : []);
      }
      
    } finally {
    }
  };

  const handleSearch = (filtervalue) => {
    setFilters((prev) => ({ ...prev, search: filtervalue }));
  };

  const handleFilter = (filtervalue) => {
    setFilters(filtervalue);
  };

  useEffect(() => {
    fetchCustomerData();
  }, [currentPage, filters]);

  return {
    
    loading,
    fetchCustomerData,
  };
};

export default userChatUserList;
